module.exports = __webpack_public_path__ + "static/media/step2img11.e5f89d27.PNG";